export default __webpack_public_path__ + "static/media/buzzer.22714f03.svg";